import React, { useEffect, useState } from "react";

import { Box, CircularProgress } from "@mui/material";

import MaterialTabs from "@mui/material/Tabs";
import MaterialTab from "@mui/material/Tab";

import { createStyles, makeStyles } from "@mui/styles";

import TabPanel from "./TabPanel";
import { useHistory, useLocation } from "react-router-dom";

const useStyles = makeStyles(() =>
  createStyles({
    label: {
      fontWeight: "bold !important",
      textTransform: "none !important",
    },
  })
);

const TabBold = (props) => {
  const classes = useStyles();

  return <MaterialTab disableRipple className={classes.label} {...props} />;
};

const useTab = (onTabChange = () => {}) => {
  const history = useHistory();
  const location = useLocation();
  const redirectFrom = location?.state?.from;

  const setTab = (url = "", tabIdx = 0, openNewTab = false) => {
    if (url) {
      if (url.includes("timeline")) {
        tabIdx = 0;
      } else if (url.includes("details")) {
        tabIdx = 1;
      } else if (url.includes("comments")) {
        tabIdx = 2;
      } else if (url.includes("documents")) {
        tabIdx = 3;
      } else if (url.includes("templates")) {
        tabIdx = 4;
      } else if (url.includes("associated")) {
        tabIdx = 5;
      } else if (url.includes("audit")) {
        tabIdx = 6;
      }

      if (openNewTab) window.open(url, "_blank", "noopener,noreferrer");
      else history.push(url, { from: redirectFrom });
    }

    onTabChange(tabIdx);
  };
  return {
    setTab: setTab,
  };
};

const a11yProps = (index) => ({
  id: `simple-tab-${index}`,
  "aria-controls": `simple-tabpanel-${index}`,
});

const Tab = ({ children }) => <div>{children}</div>;

const Tabs = ({ tabState, children: tabs, onTabChange = () => {} }) => {
  // disabling rules of hooks here to conditionally
  // use a useState passed in from props or create our own useState
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [value, setValue] = tabState || useState(0);

  const handleChange = (event, changedValue) => {
    setValue(changedValue);
    onTabChange(changedValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <MaterialTabs
          value={value}
          onChange={handleChange}
          aria-label="material-tabs"
          style={{ minHeight: "32px" }}
        >
          {tabs
            .filter((tab) => Boolean(tab?.props?.label))
            .map((tab, i) => (
              <TabBold
                label={tab?.props?.label}
                disabled={tab?.props?.disabled}
                {...a11yProps(i)}
              />
            ))}
        </MaterialTabs>
      </Box>
      {tabs
        .filter((tab) => Boolean(tab?.props?.label))
        .map((tab, i) => (
          <TabPanel value={value} index={i}>
            {tab?.props?.component}
          </TabPanel>
        ))}
    </Box>
  );
};

export default Tabs;
export { Tab, useTab };
